<template>
    <div class="change-buttons">
        <el-button @click="cancel" size="small">
            Cancel
        </el-button>
        <el-button @click="change" size="small" type="primary">
            {{ getName }}
        </el-button>
    </div>
</template>

<script>

export default {
	name: 'change-buttons',
    props: {
        name: {
            type: String
        }
    },
	data() {
		return {
		}
    },
    methods: {
        change() {
			this.$emit('change')
		},
		cancel() {
			this.$emit('cancel')
        }
    },
    computed: {
        getName() {
            return this.name ? this.name : 'Change'
        }
    }
}
</script>

<style lang="scss" scoped>
.change-buttons {
    margin-top: 10px;
}
</style>